import { SimpleShowLayout, Show, TextField, Labeled, ReferenceField } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import BackButtonToolbar from "features/BackButtonToolbar";
import { administrationRequests } from "api/administrationApi";
import { SectionTitle } from "features/SectionTitle";

const ShowTechnicalEquipmentTypes = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Show
      title="Детайли за техническо оборудване"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />

        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Име на български език">
              <TextField source="nameBg" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Модел">
              <TextField source="model" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Производител">
              <TextField source="manufacturer" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Сериен номер">
              <TextField source="serialNumber" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Инвентарен номер">
              <TextField source="inventoryNumber" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Описание">
              <TextField source="description" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Катедра">
              <ReferenceField
                source="departmentId"
                reference={administrationRequests.getDepartmentsSelect()}
              >
                <TextField source="fullName" />
              </ReferenceField>
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowTechnicalEquipmentTypes;
